module.exports = __webpack_public_path__ + "img/ATHAR-popup.0cac5113.png";